import { ComplianceDocumentType, ComplianceDocumentTypeFE } from 'domain/shared/compliance';
import { SearchInput, useInputHelper } from 'framework/form';
import { ListParams, useListContext } from 'framework/list';

type ComplianceDocumentTypeSuggestionInputProps = {
  source: string;
  label: string;
  placeholder: string;
  disabled: boolean;
};

// Input works only with useListContext
const ComplianceDocumentTypeSuggestionInput = ({ source, ...props }: ComplianceDocumentTypeSuggestionInputProps) => {
  const { getRawOnChangeCallback } = useInputHelper({ source });
  const { data } = useListContext();
  const { items } = data || ({ items: [] } as { items: ComplianceDocumentTypeFE[] });

  const onChangeCallback = getRawOnChangeCallback();
  const onInputChangeCallback = (resultValue: string) => {
    onChangeCallback?.({ [source]: resultValue });
  };

  const selectSuggestionMethod = (resultValue: StringOrNumber) => {
    const element = items!.find(
      item => item.metadata.complianceName.toLowerCase() === String(resultValue).toLowerCase(),
    );
    if (!element) {
      return;
    }

    onChangeCallback?.({
      [source]: element?.metadata?.complianceName,
      complianceType: element?.metadata?.complianceType,

      isAllEmployee: element?.metadata?.isAllEmployee,
      positionIds: element?.metadata?.positionIds,
      offices: element?.metadata?.offices,
      businessRegistrationCountries: element?.metadata?.businessRegistrationCountries,
      relatedEmployeeContractTypes: element?.metadata?.relatedEmployeeContractTypes,
      assignments: element?.metadata?.assignments,

      isSignatureRequired: element?.metadata?.isSignatureRequired,
      gracePeriodDays: element?.metadata?.gracePeriodDays,
    });
  };

  const loadSuggestions = (query: ListParams) => {
    const {
      searchString: { ct: searchString = '' },
    } = query.filter || { searchString: { ct: '' } };

    const rez = items!.filter(
      item =>
        item?.metadata?.complianceName &&
        item.metadata.complianceName.toLowerCase()?.includes(searchString.toLowerCase()),
    );

    return {
      result: rez,
      totalPages: 1,
    };
  };

  const mapResults = (item: ComplianceDocumentType) => {
    return {
      id: item.metadata.complianceName,
      text: item.metadata.complianceName,
    };
  };

  return (
    <SearchInput
      selectSuggestionMethod={selectSuggestionMethod}
      onInputChangeCallback={onInputChangeCallback}
      searchRequest={loadSuggestions}
      mapResults={mapResults}
      source={source}
      nameSource={source}
      {...props}
    />
  );
};

export default ComplianceDocumentTypeSuggestionInput;
